
export default {
  ADD_BRAND_REVIEWS (state, reviews) {
    state.brandReviews = reviews
  },
  UPDATE_BRAND_REVIEW (state, review) {
    const oldReview = state.brandReviews.find(r => r.id === review.id)
    if (oldReview) {
      Object.assign(oldReview, review)
    }
  },
  DELETE_BRAND_REVIEW (state, id) {
    state.brandReviews = state.brandReviews.filter(s => s.id !== id)
  },
  ADD_BRAND_ACHIEVEMENTS (state, reviews) {
    state.brandAchievements = reviews
  },
  UPDATE_BRAND_ACHIEVEMENT (state, review) {
    const oldAchievement = state.brandAchievements.find(r => r.id === review.id)
    if (oldAchievement) {
      Object.assign(oldAchievement, review)
    }
  },
  DELETE_BRAND_ACHIEVEMENT (state, id) {
    state.brandAchievements = state.brandAchievements.filter(s => s.id !== id)
  },
  ADD_RECOMMENDATION_LETTERS (state, letters) {
    state.recommendationLetters = letters
  },
  UPDATE_RECOMMENDATION_LETTER (state, letter) {
    let oldLetter = state.recommendationLetters.find(r => r.id === letter.id)
    if (oldLetter) {
      Object.assign(oldLetter, letter)
    }
  },
  DELETE_RECOMMENDATION_LETTER (state, id) {
    state.recommendationLetters = state.recommendationLetters.filter(s => s.id !== id)
  },
  ADD_BROKERAGE_HOUSES (state, houses) {
    state.brokerageHouses = houses
  },
  UPDATE_BROKERAGE_HOUSE (state, house) {
    let oldHouse = state.brokerageHouses.find(r => r.id === house.id)
    if (oldHouse) {
      Object.assign(oldHouse, house)
    }
  },
  DELETE_BROKERAGE_HOUSE (state, id) {
    state.brokerageHouses = state.brokerageHouses.filter(s => s.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/history.js